
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CPCheckboxAccordion extends Vue { 
  @Prop({ required: false, default: null })
  public readonly error!: string | null;
}
